/**
 * Maintenance Mode State
 *
 * Observable global state that tracks whether the platform is in maintenance mode.
 * Set by the API client when it receives a 503 MAINTENANCE_MODE response.
 */

type Listener = (active: boolean, message: string | null) => void;

let isActive = false;
let message: string | null = null;
const listeners = new Set<Listener>();

function notify() {
  listeners.forEach((l) => l(isActive, message));
}

export const maintenanceState = {
  setActive(msg: string | null) {
    isActive = true;
    message = msg;
    notify();
  },

  clearActive() {
    isActive = false;
    message = null;
    notify();
  },

  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  getState() {
    return { isActive, message };
  },
};
